// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"header_mainContainer__4kXIs"};